export default {
    googleMaps: null
}
